import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';

export const WrapperBox = styled(Box)`
  position: relative;
  @media screen and (min-width: 36rem) {
    overflow: hidden;
  }
  ${themeMediaQuery('sm')} {
    overflow: visible;
  }
`;

export const BeAmazingBox = styled(Box)`
  position: relative;
  display: flex;
  overflow: hidden;
  min-height: var(--sectionMinHeight);
  ${themeMediaQuery('below_sm')} {
    height: 827px;
  }
  @media screen and (min-width: 36rem) {
    height: auto;
  }
  ${themeMediaQuery('sm')} {
    margin-top: 0px;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 100%;
`;

export const MobileCloudImage = styled(CloudImage)`
  width: 100%;
`;

export const OutlineArtBox = styled(Box)`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 32.5%;
`;

export const FillArtBox = styled(Box)`
  position: absolute;
  left: 0;
  bottom: 52%;
  width: 19.7%;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  ${themeMediaQuery('sm')} {
    bottom: 66%;
  }
  ${themeMediaQuery('md')} {
    bottom: 57%;
  }
  @media (min: width: 1400px) {
    bottom: 45%;
  }
  ${themeMediaQuery('lg')} {
    bottom: 54%;
  }
  ${themeMediaQuery('lg')} {
    bottom: 45%;
  }
`;

export const TextWrapperBox = styled(Box)`
  position: absolute;
  width: 100%;
  top: 16vw;
  left: 50%;
  transform: translate(-50%, 0);
  @media screen and (min-width: 36rem) {
    top: 50vw;
  }
  ${themeMediaQuery('sm')} {
    top: 5vw;
    transform: translate(-40%, 0);
  }
  @media (min-width: 1400px) {
    transform: translate(-50%, 0);
  }
  ${themeMediaQuery('lg')} {
    left: 50%;
    transform: translate(-50%, 0);
  }
`;

export const StyledText = styled(Text)`
  text-align: left;
  ${themeMediaQuery('sm')} {
    width: 600px;
  }
  ${themeMediaQuery('md')} {
    width: 438px;
  }
  ${themeMediaQuery('xl')} {
    width: 510px;
  }
`;

export const NameStyledText = styled(Text)`
  text-align: left;
`;

export const PerksTextPairing = styled(TextPairing)`
  text-align: center;
  align-items: center;
  max-width: 390px;
  margin: auto;
  ${themeMediaQuery('xl')} {
    max-width: 520px;
  }
`;

export const PerksBox = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    div {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const PerksIconTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 292px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      margin: auto;
    }
  }
`;

export const DiversityText = styled(Text)`
  text-align: center;
  margin-top: ${themeSpace(11)};
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(5)};
  }
`;

export const DiversityBodyText = styled(Text)`
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  ${themeMediaQuery('sm')} {
    max-width: 445px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 524px;
  }
`;

export const BadgeFlex = styled(Flex)`
  align-items: center;
  justify-content: center;
`;

export const BadgeCloudImage = styled(CloudImage)`
  width: 11%;
  padding: 0 1rem;
  ${themeMediaQuery('below_sm')} {
    width: 50%;
  }
  ${themeMediaQuery('sm')} {
    width: 22%;
  }
  @media (min-width: 1400px) {
    width: 15%;
  }
  ${themeMediaQuery('lg')} {
    width: 11%;
  }
`;

export const DiversityColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

export const DiversityTopColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    order: 2;
  }
`;

export const DiversityBottomColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    display: initial;
    order: 1;
  }
`;
